import { PECOS_ELIGIBLE } from './constants';
/**
 * Performs a call to PIM to check pecos statis for the provided npi number.
 * It will process the response and return true if the doctor is approved,
 * false otherwise.
 * This function defaults to false so that in the event of network errors, there
 * isnt a chance the physician is approved when they should not be.
 */

export const checkIfPecosApproved = async (npi, pim, verbalDate, agency) => {
  if (!npi || !pim || !verbalDate || !agency) {
    return false;
  }

  let status = false;

  try {
    const res = await pim.checkIfPECOSApproval(npi, verbalDate, agency);

    if (!(res instanceof Response) && res[0]) {
      const response = res[0];

      if ((response === null || response === void 0 ? void 0 : response.eligibilityStatus) === PECOS_ELIGIBLE) {
        status = true;
      }
    }
  } catch (e) {
    console.error(e);
  }

  return status;
};